import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, MenuProps } from 'antd';
import { getNavbarMenuItemColor, getNavbarMenuItemIcon } from 'helpers/menu-helpers';
import { MenuItem } from 'pages/home/models/types/home';
import { FC, useState } from 'react';
import styles from './main-menu.module.scss';
import { getMenuItemChild } from './menu-item-child';
import { useNavigate } from 'react-router';

interface MenuItemParentProps {
  menuItem: MenuItem;
}
export const MenuItemParent: FC<MenuItemParentProps> = ({ menuItem }) => {
  const [isVisible, setVisible] = useState<boolean>(false);
  const nav = useNavigate();

  const items: MenuProps['items'] = [...menuItem.childMenuItems.map(item => getMenuItemChild(item, nav, () => setVisible(false)))];
  return (
    <div className={isVisible ? styles.active : styles.hover}>
      <Dropdown
        onOpenChange={visible => {
          setVisible(visible);
        }}
        menu={{ items }}>
        <span className={styles.flexButton}>
          <span className={styles.title} style={{ color: getNavbarMenuItemColor(menuItem) }}>
            {menuItem.titel}
          </span>
          <FontAwesomeIcon className={styles.icon} style={{ color: getNavbarMenuItemColor(menuItem) }} icon={getNavbarMenuItemIcon(menuItem)} />
        </span>
      </Dropdown>
    </div>
  );
};
